import { createSelector } from 'reselect';

const selectChannelPrograms = (state: any) => state.channelPrograms;


export const selectChannelProgramsCurrentItem = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.current);

export const selectChannelProgramsListItems = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.list);

export const selectChannelProgramsItemById = (itemId: any) =>
    createSelector(selectChannelProgramsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectChannelProgramsQueryItems = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.query);

export const selectChannelProgramsCreatedItem = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.create);

export const selectChannelProgramsUpdatedItem = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.update);

export const selectChannelProgramsReadItem = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.read);

export const selectChannelProgramsDeletedItem = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.delete);

export const selectChannelProgramsSearchedItems = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.search);

export const selectChannelProgramsItemsCount = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.count);

export const selectChannelProgramsItemsFilter = createSelector([selectChannelPrograms], (channelPrograms) => channelPrograms.filter);